module.exports = __webpack_public_path__ + "static/media/18.e00e9230.wav";